<template>
  <div>
    {{ formattedDate }}
  </div>
</template>

<script>
export default {
  props: ['params'],
  computed: {
    formattedDate() {
      if (!this.params.value) return '';

      const rawValue = String(this.params.value).trim();
      const hasTimeComponent = rawValue.includes('T') && rawValue.includes(':');

      // Date-only values should be rendered as a local calendar date without timezone shifting.
      if (!hasTimeComponent) {
        const dateOnlyMatch = rawValue.match(/^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})$/);
        if (dateOnlyMatch) {
          const year = Number(dateOnlyMatch[1]);
          const month = Number(dateOnlyMatch[2]);
          const day = Number(dateOnlyMatch[3]);
          const localDate = new Date(year, month - 1, day);
          if (
            localDate.getFullYear() === year &&
            localDate.getMonth() === month - 1 &&
            localDate.getDate() === day
          ) {
            return new Intl.DateTimeFormat(undefined, {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            }).format(localDate);
          }
        }
      }

      const date = new Date(rawValue);
      if (isNaN(date.getTime())) return rawValue;

      if (hasTimeComponent) {
        return new Intl.DateTimeFormat(undefined, {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        }).format(date);
      }

      return new Intl.DateTimeFormat(undefined, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).format(date);
    }
  }
};
</script>
